import { addError } from 'rdx/alert';
import * as API from 'service/ErplyAPI/pointsOfSale';

import * as types from './types';

export const fetchPointsOfSale = (params) => async (dispatch) => {
  dispatch({ type: types.FETCH_POS.START });
  try {
    const pointsOfSale = await API.getPointsOfSale(params);
    dispatch({
      type: types.FETCH_POS.SUCCESS,
      payload: pointsOfSale.records,
    });
  } catch (error) {
    dispatch(addError(error.message));
    dispatch({ type: types.FETCH_POS.ERROR, payload: error.message });
  }
};
